export default class Buyer {
    fullName        = null;
    dateBirth       = null;
    cpf             = null;
    phone           = null;
    email           = null;
    confirmEmail    = null;

    constructor(){ }
}



    